import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxAccordionModule } from '@aposin/ng-aquila/accordion';
import { NxGridModule } from '@aposin/ng-aquila/grid';
import { NxDataDisplayModule } from '@aposin/ng-aquila/data-display';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxInputModule } from '@aposin/ng-aquila/input';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxTableModule } from '@aposin/ng-aquila/table';
import { NxListModule } from '@aposin/ng-aquila/list';
import { NxSwipebarModule } from '@aposin/ng-aquila/swipebar';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxCheckboxModule } from '@aposin/ng-aquila/checkbox';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NxModalModule } from '@aposin/ng-aquila/modal';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { NxDatefieldModule } from '@aposin/ng-aquila/datefield';
import { Moment } from 'moment';
import { NxMomentDateModule } from '@aposin/ng-aquila/moment-date-adapter';
import { NxRadioModule } from '@aposin/ng-aquila/radio-button';
import { SummaryPopupComponent } from "../../../popup/summary-popup/summary-popup.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { Observable, Subject, delay, of, takeUntil } from 'rxjs';
import { CrossSellBannerComponent } from '@shared/components/cross-sell-banner/cross-sell-banner.component';
import { ViewRemarksComponent } from '@shared/components/view-remarks/view-remarks.component';
import { VehicleViewAmendmentComponent } from '@shared/components/vehicle-view-amendment/vehicle-view-amendment.component';
import {
  CALCULATE_PREMIUM,
  SELECTED_MAKE_MODEL,
  CALCULATE_PREMIUM_SUMMARY,
  GET_CUSTOMER_PARTNER_MOCK,
  GENERATE_QUOTATION,
  SEND_TO_JPJ,
  DOWNLOAD_PDF,
  SET_JPJ_STATUS_SENT,
  CALCULATE_PREMIUM_PAYLOAD,
  GET_DOCUMENT_LOV,
  STORE_ISSUANCE_SUMMARY,
  GET_QUOTATION_DETAIL,
  CANCEL_REPLACE,
  REQUEST_CANCELLATION,
  STORE_AGENT_FROM_RESPONSE,
  STORE_ISSUANCE_FROM_RESPONSE,
  COPY_CNGE_INFO_RENEWAL,
  COPY_CNGE_INFO_VIEW_QUOTATION,
  GET_PRODUCT_LIST,
  STORE_EXTRA_COVER_PACKAGE,
  GET_SWITCH_SITE,
  GET_CROSS_SELL_LIST,
  GET_QUOTATION_DETAIL_REQUOTE,
  COPY_DRAFT_INFO,
  COPY_REQUOTE_INFO,
  RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ,
  COPY_CNGE_INFO,
  CANCEL_QUOTATION,
  CANCEL_COVER_NOTE,
  SET_ACTION,
  GET_AGENT_LIST_AGENT,
  GET_CCENTRIC_OPPORTUNITY_INFO,
  GET_VEHICLE_USE,
  SET_UPDATE_PAYMENT_IND,
  SET_OPPORTUNITY_ID,
  SAVE_REFERRAL_REMARKS,
  AMEND_OPENDATE,
  IS_CANCEL_REPLACE_COVER_NOTE,
  RESEND_JPJ,
  UPDATE_QUOTATION_GET_CCENTRIC_OPPORTUNITY_INFO,
  SEARCH_ORIXCompanyInfo,
  SEARCH_MAKE_MODEL,
  CHECK_PRINTING_CUTOFF,
  ISSUANCE_CALCULATE_PREMIUM_SUMMARY,
  STORE_EXTRA_COVER_SUMMARY,
  STORE_NCD_INFO,
  GET_EMAIL_CUTOFF,
  STORE_SHOWED_ONE_ALLIANZ_POP_UP,
  SET_IS_CREATED_BY_CC_USER,
  GET_NCD_ENQUIRY,
  STORE_COVERAGE_VEHICLE_DETAILS,
  STORE_COVERAGE_TYPE,
  PATCH_STEP3,
  STORE_PREMIUM_CALCULATION_PAYLOAD
}
  from "@store/sat-motor/sat-motor.action";
import { SharedModule } from '@shared/shared.module';
import { PaymentModeComponent } from '@shared/components/modal/payment-mode/payment-mode.component';
import { OneAllianzMessageComponent } from '@shared/components/modal/one-allianz-message/one-allianz-message.component';
import { PaymentDetailsComponent } from '@shared/components/payment-details/payment-details.component';
import { UpsellProductComponent } from '@shared/components/upsell-product/upsell-product.component';
import { MakeModelComponent } from "@shared/components/modal/make-model/make-model.component";
import { NumberRangeValidator } from "@shared/classes/validators/number-range.validator";
import { UserResponse } from "@interfaces/user";
import { CoverageSummaryComponent } from '@shared/components/coverages/coverage-summary/coverage-summary.component';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { EnquiryPopupComponent } from 'src/app/popup/enquiry-popup/enquiry-popup.component';
import { RequestCancellationComponent } from '@shared/components/modal/request-cancellation/request-cancellation.component';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ACTIONS } from '@shared/enums/index.enum';
import { ClauseMessageComponent } from '@shared/components/modal/clause-message/clause-message.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { EmailDocumentComponent } from '@shared/components/modal/email-document/email-document.component';
import { PaymentComponent } from '@shared/components/payment/payment.component';
import { RoadTaxPayableComponent } from '@shared/components/road-tax-payable/road-tax-payable.component';
import { PaymentInformationComponent } from '@shared/components/payment-information/payment-information.component';
import { ViewRoadTaxPayableComponent } from '@shared/components/view-road-tax-payable/view-road-tax-payable.component';
import { ViewUpsellProductComponent } from '@shared/components/view-upsell-product/view-upsell-product.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { RemarksComponent } from '@shared/components/modal/remarks/remarks.component';
import {StatusMessageComponent} from "@shared/components/status-message/status-message.component";
import { WarningPopupComponent } from '@shared/components/modal/warning-popup/warning-popup.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';

@Component({
  selector: 'app-view-quotation',
  standalone: true,
  imports: [
    NxAccordionModule,
    NxGridModule,
    NxDataDisplayModule,
    NxCopytextModule,
    NxButtonModule,
    NxIconModule,
    NxDropdownModule,
    NxInputModule,
    NxFormfieldModule,
    NxHeadlineModule,
    NxTableModule,
    NxListModule,
    NxSwipebarModule,
    NxCardModule,
    NxCheckboxModule,
    TextFieldModule,
    NxModalModule,
    NxDatefieldModule,
    NxMomentDateModule,
    NxRadioModule,
    SharedModule,
    PaymentDetailsComponent,
    UpsellProductComponent,
    CoverageSummaryComponent,
    OkMessageComponent,
    CrossSellBannerComponent,
    ViewRemarksComponent,
    VehicleViewAmendmentComponent,
    PaymentComponent,
    RoadTaxPayableComponent,
    PaymentInformationComponent,
    ViewRoadTaxPayableComponent,
    ViewUpsellProductComponent,
    StatusMessageComponent
  ],
  templateUrl: './view-quotation.component.html',
  styleUrl: './view-quotation.component.scss'
})
export class ViewQuotationComponent implements OnInit {
  @ViewChild(VehicleViewAmendmentComponent) vehicleAmendData!: VehicleViewAmendmentComponent;
  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.commonLov) commonLov$;
  @Select(SatMotorState.searchORIXLov) searchORIXLov$;
  @Select(SatMotorState.copyCngeComplete) copyReady$;

  private destroy$ = new Subject<void>();
  isIssuance: boolean = false;
  isEndorsement: boolean = false;
  isEnquiry: boolean = false;
  isRTP: boolean = false;
  isCCentric: boolean = false;

  requestCancellationModal?: NxModalRef<RequestCancellationComponent>;
  clauseMsgModal?: NxModalRef<ClauseMessageComponent>;
  emailDocumentModal?: NxModalRef<EmailDocumentComponent>;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;
  remarksModal?: NxModalRef<RemarksComponent>;
  warningPopupModal?: NxModalRef<WarningPopupComponent>;
  cnoteStatus: any;
  quotationDetail: any;
  progressType: any;
  userInfo: any;
  agentData: any;
  issuanceInfo: any = {};
  clientClaimHistory: any;
  vehicleClaimHistory: any;
  premiumInfo: any;
  coverageInfo: any;
  cpData: any;
  lov: any;
  isProgressTypeCN: boolean = false;
  isProgressTypeENDST: boolean = false;
  isProgressTypeRTP: boolean = false;

  showAgentInfo: boolean = false;
  showIssuanceInfo: boolean = false;
  showCustomerPartner: boolean = false;
  showReferralDetails: boolean = false;
  showSalesmanID: boolean = false;
  showCoverage: boolean = false;
  showHistoricalClaim: boolean = false;
  showPremiumInformation: boolean = false;
  showReferCase: boolean = false;
  showPayment: boolean = false;
  showUpsellProduct: boolean = false;
  showPaymentInformation: boolean = false;
  showPaymentDetails: boolean = false;
  showChecklist: boolean = false;
  showRenewalAssistant: boolean = false;
  showEndorsementNarration: boolean = false;
  showRoadTaxPayable: boolean = false;
  showEndorsementErrMessage: boolean = false;
  sundriesAgent: boolean = false;
  showRemarks: boolean = false;
  contractId: any;
  mock: any;
  token: any;
  referralForm: FormGroup;
  referCaseForm: FormGroup;
  callIssuanceInformation: boolean = false;
  viewQuotation: boolean = true;
  popupMessage: any;
  referralReasonList: any;
  status: any;
  classType: any;
  type: any;
  proposalNo: any;
  productName: any;
  dialogRef?: NxModalRef<any>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  productList: any;
  remarksInfo: any;
  agentReferId: string;
  frStaffNo: string;
  responseData: any;
  cngeNote: any;
  isDataLoaded: boolean = false;
  queryParams: any = {};
  crossSellList: any = [];
  marketingConsent: any;
  isUpdateJPJScreen: boolean = false;
  isAmendDateScren: boolean = false;
  showPrimaryScreen: boolean = true;
  showSecondaryScreen: boolean = false;

  isShowBackBtn: boolean = false;
  isShowRequestCancellationBtn: boolean = false;
  isShowUpdateQuotationBtn: boolean = false;
  isShowSendToJPJBtn: boolean = false;
  isShowUploadDocumentBtn: boolean = false;
  isShowAddRemarksBtn: boolean = false;
  isUpdatePaymentBtn: boolean = false;
  isShowDownloadQuotationBtn: boolean = false;
  isShowDownloadCoverNoteBtn: boolean = false;
  isShowDownloadInvoiceBtn: boolean = false;
  isShowUpdateJPJBtn: boolean = false;
  isShowAmendCoverNoteBtn: boolean = false;
  isShowEmailDocumentBtn: boolean = false;
  isShowRequoteBtn: boolean = false;
  isShowMarketingBtn: boolean = false;
  isShowIssueNewBtn: boolean = false;

  motorPC: any;
  lovproductConfig: any;
  productAccessListData: any;
  lovPC: string;
  lovGeo: any;
  emailCheck : any;
  edocConsentInd: boolean = false;
  eInvoiceConsentInd : boolean;
  payment: any;
  paymentList: any;
  roadTaxPayable: any;
  paymentInformation: any;
  upsellProduct: any;
  agentInfo: any;
  isNotAllowCancel: boolean = false;
  isDirectCancel: boolean = false;
  message: any;
  dataORIXLeasingLov: any;
  opportunityId: any;
  isCreatedByCcUser: boolean = false;
  latestPremiumCalculation: any;
  isFromMotorApproval: boolean = false;

  yearList = [
    { code: '2024', name: '2024' },
    { code: '2025', name: '2025' },
    { code: '2026', name: '2026' },
    { code: '2027', name: '2027' }
  ];

  statusMap = {
    PRINTED: "Printed",
    APPROVED: "Approved",
    PENDING: "Pending Approval",
    CANCELLED: "Cancelled",
    SUBMITTED: "Submitted",
    ACTIVE: "Active",
    EXPIRED: "Expired"
  };

  classTypeMap = {
    PRINTED: "printed_badge",
    APPROVED: "approved_badge",
    PENDING: "pending_badge",
    CANCELLED: "cancel_badge",
    SUBMITTED: "submitted_badge",
    ACTIVE: "active_badge",
    EXPIRED: "expired_badge"
  };

  NCD_WO_NOTIFICATION = [
    "ENQ000", "ENQ014", "ENQ016", "ENQ017", "ENQ030", "ENQ044", "ENQ051", "ENQ057", "ENQ060", "ENQ062", 
    "ENQ063", "ENQ067", "ENQ078", "ENQ079", "ENQ080", "ENQ081", "ENQ088", "ENQ089", "ENQ092", "ENQ096"
  ];  


  @Select(SatMotorState.premiumCalculationSummary) premiumCalculationSummary$: Observable<SatMotorState>;

  alimCustomerInd: boolean;
  hasShowedOneAllianzPopUp: boolean;
  oneAllianzModal?: NxModalRef<OneAllianzMessageComponent>;

  constructor(
    private dialogService: NxDialogService,
    public store: Store,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private accessService: MenuAccessService,
    private cdr: ChangeDetectorRef
  ) {
    this.referralForm = this.fb.group({
      referralId: ['', Validators.required]
    });

    this.referCaseForm = this.fb.group({
      waiveLoadInd: [{ value: false, disabled: true }],
      waiveExcessInd: [{ value: false, disabled: true }],
      underwritingInd: [true],
      remarks: ['', Validators.required]
    });
  }

  renewalAssistanceForm = new FormGroup({
    renewalAssistant: new FormControl(false),
    paymentMode: new FormControl(''),
    creditCardNo: new FormControl(''),
    creditCardExpiryDateMonth: new FormControl(''),
    creditCardExpiryDateYear: new FormControl(''),
    nameOnCard: new FormControl(''),
    termofUse: new FormControl(false),
    renewalAssistanceStartDate: new FormControl('')
  });

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    this.queryParams = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.edocConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.edocConsentInd);
    this.eInvoiceConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.einvoiceConsentInd);
    this.isCCentric = this.queryParams.opportunityId;
    this.opportunityId = this.store.selectSnapshot<any>(state => state.SatMotorState.opportunityId);
    this.isFromMotorApproval = this.queryParams?.isFromMotorApproval;
    this.actionType$.subscribe((state) => {
      if (state) {
        this.isIssuance = state.isIssuance;
        this.isEndorsement = state.isEndorsement;
        this.isEnquiry = state.isEnquiry;
        this.isRTP = state.isRTP;
      }
    });

    this.commonLov$.subscribe((state) => {
      if (state) {
        this.lov = state;
      }
    });

    this.searchORIXLov$.subscribe((state) => {
      if (state) {
        this.dataORIXLeasingLov = state;
      }
    })

    if (this.isRTP) {
      this.store.dispatch(new GET_QUOTATION_DETAIL(this.queryParams.contractId, "SUMMARY")).subscribe((state) => {
        const rtpPolicy = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp?.step1?.rtpPolicy?.data?.cngeNoteDto);
        const sendJPJResponse = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp?.step2?.sendToJPJ?.data?.cngeNoteDto);
        
        this.populateCommonData(state, sendJPJResponse);
        this.showReferralDetails = this.responseData.mkagAgent.channel === 'AG' || this.responseData.mkagAgent.sundriesAgent;
        this.showSalesmanID = this.responseData.mkagAgent.enableSalesmanId;
        if (!this.issuanceInfo.issuance.eCoverNoteNo) {
          this.issuanceInfo = {
            ...this.issuanceInfo,
            issuance: {
              ...this.issuanceInfo.issuance,
              eCoverNoteNo: sendJPJResponse.cnoteNo
            }
          };
        }
        
        this.isProgressTypeRTP = true;
        this.progressType = 'rtp';
        this.showComponents();
        this.isDataLoaded = true;
      });
    } else if(this.isCCentric) {
      this.type = 'view-quotation-enquiry';
      this.popupMessage = 'Your e-Cover Note has been submitted as pending approval.';

      this.searchCoverNoteByOpportunityId();
      
    } else {
      this.type = 'view-quotation-enquiry';
      this.popupMessage = 'Your e-Cover Note has been submitted as pending approval.';

      let action = "SUMMARY"+"&operator="+this.userInfo.userId;
      this.searchCoverNoteByContractId(action, true);
      
    }

  }

  searchCoverNoteByOpportunityId() {
    const param = {
      "opportunityId": this.queryParams.opportunityId,
      "action": "SUMMARY"
    };

    this.store.dispatch(new GET_CCENTRIC_OPPORTUNITY_INFO(param)).subscribe((state) => {
      this.agentInfo = state.SatMotorState.cCentricInfo.mkagAgent;
      if(state.SatMotorState.viewQuotationData){
        this.getVehicleLov(state.SatMotorState.viewQuotationData?.cngeNote?.productCode, true);
      }
      this.populateCommonData(state, null);

      this.showRemarks = !!this.remarksInfo;
      this.showReferralDetails = this.responseData.mkagAgent.channel === 'AG' || this.responseData.mkagAgent.sundriesAgent;
      this.showSalesmanID = this.responseData.mkagAgent.enableSalesmanId;

      const getCrossSellListPayload = {
        "agentCode": this.agentData.agentCode,
        "partnerId": this.cpData.partnerId,
        "idType": this.cpData.idType1,
        "idValue": this.cpData.idValue1
      };
      this.store.dispatch(new GET_CROSS_SELL_LIST(getCrossSellListPayload, this.cngeNote.productCode)).subscribe(state => {
        this.crossSellList = state.SatMotorState.data.step5.crossSellList;
        this.marketingConsent = state.SatMotorState.data.step5.marketingConsent;
        console.log("cross sell list: ", this.crossSellList);
      });

      let calculatePremiumPayload  = state?.SatMotorState?.viewQuotation;
      if (calculatePremiumPayload?.riskList[0]?.coverList[0]?.subCovPackage) {
        calculatePremiumPayload = {
          ...calculatePremiumPayload,
          riskList: [
            {
              ...calculatePremiumPayload.riskList[0],
              coverList: [
                {
                  ...calculatePremiumPayload.riskList[0].coverList[0],
                  coverDto: {
                    ...calculatePremiumPayload.riskList[0].coverList[0].coverDto,
                    extCovPackageSelected: calculatePremiumPayload.riskList[0].coverList[0].subCovPackage
                  }
                }
              ]
            }
          ]
        };
      }

      this.store.dispatch(new CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(state => {

        this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
        let latestCoveragePremium = state?.SatMotorState?.premiumCalculation;
        let hasSubCovPackageList = latestCoveragePremium?.coverDto?.subCovPackageList;
        let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
        let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0); 



        if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
          let latestSubCovList = latestCoveragePremium?.coverDto?.subCovList;
                    
          if (hasWaiver) {
            latestSubCovList = latestSubCovList?.map(obj => {
              if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                return { ...obj, selected: true }
              }
              return obj;
            })
          }

          calculatePremiumPayload = {
            ...calculatePremiumPayload,
            riskList: [{
              ...calculatePremiumPayload.riskList[0],
              coverList: [{
                ...calculatePremiumPayload.riskList[0].coverList[0],
                coverDto: {
                  ...calculatePremiumPayload.riskList[0].coverList[0].coverDto || {},
                  subCovList: latestSubCovList || [],
                  subCovPackageList: hasSubCovPackageList
                }
              }]
            }]
          };

          this.store.dispatch(new CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(state => {

            let premiumResponse = state.SatMotorState.summaryPremium;
            this.latestPremiumCalculation = state.SatMotorState.summaryPremium;

            this.premiumInfo = {
              ...this.premiumInfo,
              premiumDueRounded: premiumResponse.cCentrixPremiumDueRounded ?? this.premiumInfo.premiumDueRounded
            };
            this.getPaymentData(premiumResponse);
          });
        } else {
          let premiumResponse = state.SatMotorState.summaryPremium;
          this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
          this.premiumInfo = {
            ...this.premiumInfo,
            premiumDueRounded: premiumResponse.cCentrixPremiumDueRounded ?? this.premiumInfo.premiumDueRounded
          };
          this.getPaymentData(premiumResponse);
        }
      });

      this.isProgressTypeCN = true;
      this.progressType = 'cn';
      this.showComponents();
      this.updateButtons(this.cngeNote, this.issuanceInfo.issuance);
      this.isIssuance = true;
      this.isDataLoaded = true;
      window.scroll({ top: 0, left: 0, behavior: 'instant' });
    });
  }

  searchCoverNoteByContractId(action, isViewQuotation, contractId?) {
    let contractIdPayload = contractId ? contractId : this.queryParams.contractId;

    this.store.dispatch(new GET_QUOTATION_DETAIL(contractIdPayload, action)).subscribe((state) => {
      if(isViewQuotation && state.SatMotorState.viewQuotationError){
        this.warningPopup("warningPopupTwo",state.SatMotorState.viewQuotationError.message)
        return;
      }

      this.getVehicleLov(state.SatMotorState.viewQuotationData?.cngeNote?.productCode, true);
      this.populateCommonData(state, null);

      this.showRemarks = !!this.remarksInfo;
      this.showReferralDetails = this.responseData.mkagAgent.channel === 'AG' || this.responseData.mkagAgent.sundriesAgent;
      this.showSalesmanID = this.responseData.mkagAgent.enableSalesmanId;

      const getCrossSellListPayload = {
        "agentCode": this.agentData.agentCode,
        "partnerId": this.cpData.partnerId,
        "idType": this.cpData.idType1,
        "idValue": this.cpData.idValue1
      };
      this.store.dispatch(new GET_CROSS_SELL_LIST(getCrossSellListPayload, this.cngeNote.productCode)).subscribe(state => {
        this.crossSellList = state.SatMotorState.data.step5.crossSellList;
        this.marketingConsent = state.SatMotorState.data.step5.marketingConsent;
        console.log("cross sell list: ", this.crossSellList);
      });

      if (this.userInfo.callCenter) {
        this.agentInfo = state.SatMotorState.viewQuotation.mkagAgent;
        this.store.dispatch(new CALCULATE_PREMIUM_SUMMARY({ cngeNote: state.SatMotorState.viewQuotation, operator: this.userInfo.userId })).subscribe(state => {
          let premiumResponse = state.SatMotorState.summaryPremium;
          this.getPaymentData(premiumResponse);
        });
      }

      this.isProgressTypeCN = true;
      this.progressType = 'cn';
      this.showComponents();
      this.updateButtons(this.cngeNote, this.issuanceInfo.issuance);
      this.isIssuance = true;
      this.isDataLoaded = true;
      window.scroll({ top: 0, left: 0, behavior: 'instant' });

      this.store.dispatch(new GET_DOCUMENT_LOV({ 
        lob: "MT", 
        userId: this.userInfo.userId, 
        productCode: this.issuanceInfo.issuance.productCode,
        type: "SATMTCNDOCTYPE" }));
    });
  }

  getVehicleLov(productCode, isViewQuotation) {
    let payload = {
      productCode: productCode,
      isViewQuotation: isViewQuotation
    }
    this.store.dispatch(new GET_VEHICLE_USE(payload));
  }

  populateCommonData(state: any, sendJPJResponse: any) {
    this.responseData = state.SatMotorState.viewQuotationData;
    this.cngeNote = this.responseData.cngeNote;
    this.status = this.statusMap[this.cngeNote.cnoteStatus] || "";
    this.classType = this.classTypeMap[this.cngeNote.cnoteStatus] || "";
    this.proposalNo = sendJPJResponse ? sendJPJResponse.cnoteNo : this.cngeNote.cnoteNo || this.cngeNote.proposalNo;
  
    if(this.cngeNote.oppurtunityId) {
      this.opportunityId = this.cngeNote.oppurtunityId;
      this.store.dispatch(new SET_OPPORTUNITY_ID(this.cngeNote.oppurtunityId));
    }

    if(this.cngeNote?.createdByCcUser) {
      this.isCreatedByCcUser = this.cngeNote.createdByCcUser;
      this.store.dispatch(new SET_IS_CREATED_BY_CC_USER(this.cngeNote.createdByCcUser));
    }

    this.agentData = this.responseData.agentData;
    this.issuanceInfo = {
      ...this.responseData.issuanceInfo,
      issuance: {
        ...this.responseData.issuanceInfo.issuance,
        vehicleNo: this.responseData.coverageInfo.vehicleDetails.vehicleNo
      }
    };
    this.cpData = this.responseData.cpData;
    this.coverageInfo = {
      ...this.responseData.coverageInfo,
      vehicleDetails: {
        ...this.responseData.coverageInfo.vehicleDetails,
        leasCompCode: this.responseData.cngeNote.leasCompCode,
        buyerOverwriteInd: this.responseData.cngeNote.buyerOverwriteInd
      },
    };

    if (this.issuanceInfo.issuance.cnoteType) { //PrevSumInsured CR
      if (this.issuanceInfo?.issuance?.cnoteType === 'RN') {
        console.log('PrevSumInsured:', this.coverageInfo?.coverageDetails?.prevSumInsured ?? 'N/A');
      }

      this.coverageInfo = {
        ...this.coverageInfo,
        coverageDetails: {
          ...this.coverageInfo.coverageDetails,
          cnoteType: this.issuanceInfo.issuance.cnoteType,
        }
      };
    }

    this.premiumInfo = {
      ...this.responseData.premiumInfo,
      coverCode: this.responseData.coverageInfo?.coverageDetails?.coverCode
    };

    if(this.opportunityId || this.isCreatedByCcUser) {
      this.premiumInfo.premiumDueRounded = this.responseData.premiumInfo.cCentrixPremiumDueRounded;
    }

    this.remarksInfo = this.responseData.remarksInfo;
  
    this.clientClaimHistory = this.cngeNote.claimCnt ?? '0';
    this.vehicleClaimHistory = this.cngeNote.vehClaimCount ?? '0';

    this.agentReferId = this.cngeNote.agentReferId ?? null;
    this.frStaffNo = this.cngeNote.frStaffNo?? null;
    this.updateProductList(this.responseData.mkagAgent.agentCode, this.cngeNote.productCode);
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);

    if(this.cngeNote?.autoRenewalInd){
      this.showRenewalAssistant = true;
    }
    if (this.cngeNote.referList) {
      this.referralReasonList = this.cngeNote.referList.map(refer => {
        return {
          code: refer.referCode,
          desc: refer.referDescp
        };
      });
    }
    this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.responseData.mkagAgent.agentCode, 
          loanCompany: this.responseData.riskList[0].vehicleLoanCompany, loanType: this.responseData.riskList[0].vehicleLoanType, 
          vehType: this.cngeNote.productCode, eInvoiceInd: this.responseData.issuanceInfo.pdpa.consentDetails.einvoiceConsentInd})).subscribe((state) => {
            if (state.SatMotorState.lov.searchORIXCompany){
              this.lov = {
                ...this.lov,
                searchORIXCompany: state.SatMotorState.lov.searchORIXCompany,
              };
            }
          });

    this.message = state.SatMotorState.message;

  }

  updateButtons(cngeNote: any, issuance: any) {
    const status = cngeNote.cnoteStatus;
    const isPendingApproval = status === 'PENDING';
    const isPrintQuotation = !!(status === 'PRINTED' && cngeNote.proposalNo && !cngeNote.cnoteNo);
    const isPrintCNote = !!(status === 'PRINTED' && cngeNote.cnoteNo);
    const isPrintRTP = cngeNote.cnoteType === 'RP';
    const isCancelled = status === 'CANCELLED';
    const isExpired = status === 'EXPIRED';
    const isSubmitted = status === 'SUBMITTED';

    cngeNote = { ...cngeNote, isPendingApproval, isPrintQuotation, isPrintCNote };
    this.cngeNote = { ...cngeNote };

    this.isShowBackBtn = true;

    if (isPendingApproval) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.userInfo.agent,
        isShowAddRemarksBtn: !!this.userInfo.agent && this.userInfo.agent === true,
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowUploadDocumentBtn: true,
        isShowMarketingBtn: true,
        isShowIssueNewBtn: true
      });
    } else if (isPrintQuotation) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote),
        isShowUpdateQuotationBtn: true,
        isShowDownloadQuotationBtn: true,
        //isShowSendToJPJBtn: !!this.userInfo.agent && this.userInfo.agent === true,
        // isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true,
        isShowMarketingBtn: true,
        isShowIssueNewBtn: true
      });
    } else if (isPrintCNote) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote),
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowDownloadCoverNoteBtn: true,
        isShowDownloadInvoiceBtn: this.isShowInvoice(cngeNote),
        isShowUpdateJPJBtn: this.showUpdateUpdateJPJ(cngeNote),
        isShowAmendCoverNoteBtn: this.showAmendCoverNote(cngeNote),
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true,
        isShowMarketingBtn: true,
        isShowIssueNewBtn: true,
        isShowUpdateQuotationBtn: false,
      });
    } else if (isPrintRTP) {
      this.isShowBackBtn = true;
    } else if (isCancelled || isExpired) {
      if(isCancelled) {
        Object.assign(this, {
          isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote),
          isShowDownloadCoverNoteBtn: false,
          isShowDownloadInvoiceBtn: false,
          isShowUpdateJPJBtn: this.showUpdateUpdateJPJ(cngeNote),
          isShowAmendCoverNoteBtn: this.showAmendCoverNote(cngeNote),
          isShowUploadDocumentBtn: false,
          isShowEmailDocumentBtn: false,
          isShowMarketingBtn: false,
          isShowIssueNewBtn: false,
          isShowRequoteBtn: !!this.userInfo.agent && this.userInfo.agent === true && !this.cngeNote?.cnoteNo,
          isShowUpdateQuotationBtn: false,
          isShowDownloadQuotationBtn: false,
          //isShowSendToJPJBtn: false,
        });
      }else {
        this.isShowRequoteBtn = !!this.userInfo.agent && this.userInfo.agent === true && !this.cngeNote?.cnoteNo;
      }
    } else if (isSubmitted) {
      Object.assign(this, {
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowDownloadCoverNoteBtn: true,
        isShowDownloadInvoiceBtn: this.isShowInvoice(cngeNote),
        isShowAmendCoverNoteBtn: this.showAmendCoverNote(cngeNote), //AGIC-52637
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true,
        isShowMarketingBtn: true,
        isShowIssueNewBtn: true
      });
    }
  }

  isShowInvoice(cngeNote: any): any {
    return (cngeNote.cnoteStatus === 'PRINTED' || cngeNote.cnoteStatus === 'SUBMITTED') && cngeNote.cnoteNo && cngeNote.einvoiceConsentInd === true;
  }

  isDisableInvoicePDFButton(): boolean {
    return (this.cngeNote?.einvoiceStatus && this.cngeNote?.einvoiceStatus === 'VALID') ? this.validateAccess(AccessConfig.TAX_INVOICE) : true;
  }

  showRequestCancellation(cngeNote: any): any {
    const {
      cnoteStatus, jpjStatus, cnoteType, endtCode,
      policyNo, endtNo, createBy, updateBy
    } = cngeNote;
    const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;

    let hideButton = false;

    const fieldValues = {
      cnoteStatus, jpjStatus, cnoteType, endtCode, policyNo, endtNo,
      createBy, updateBy, userId, issueOnBehalf, issueOnEndorsement
    };

    console.log("Request Cancellation Check - Field Values:", fieldValues);

    if (cnoteStatus === "CANCELLED") {
      console.log("Cancel Button Hidden: cnoteStatus is CANCELLED");
      hideButton = true;
    } else {
      if (cngeNote.isPrintCNote) {
        if (cnoteStatus === 'PRINTED' && jpjStatus === 'SENT' && cnoteType !== 'OTTEMP') {
          console.log("Cancel Button Hidden: PRINTED status, jpjStatus SENT, and cnoteType is not OTTEMP");
          hideButton = true;
        }
        if (cnoteStatus === 'PRINTED' && jpjStatus === 'SENT' && !endtCode && policyNo) {
          console.log("Cancel Button Hidden: PRINTED status, jpjStatus SENT, no endtCode, and policyNo exists");
          hideButton = true;
        }
        if (cnoteStatus === 'PRINTED' && jpjStatus === 'SENT' && endtCode && cnoteType === 'ENDT' && endtNo) {
          console.log("Cancel Button Hidden: PRINTED status, jpjStatus SENT, endtCode present, cnoteType ENDT, and endtNo exists");
          hideButton = true;
        }
        if ((issueOnBehalf || issueOnEndorsement) && (createBy !== userId && updateBy !== userId)) {
          console.log("Cancel Button Hidden: issueOnBehalf or issueOnEndorsement with mismatched createBy/updateBy");
          hideButton = true;
        }
      }

      if (cngeNote.isPrintQuotation) {
        if ((issueOnBehalf || issueOnEndorsement) && (createBy !== userId && updateBy !== userId)) {
          console.log("Cancel Button Hidden: PrintQuotation with issueOnBehalf/issueOnEndorsement and mismatched createBy/updateBy");
          hideButton = true;
        }
        if (cnoteStatus === 'CANCELLED') {
          console.log("Cancel Button Hidden: PrintQuotation with CANCELLED status");
          hideButton = true;
        }
      }
    }

    if (!hideButton) {
      console.log("Show Cancel Button");
    }

    return !hideButton;
  }

  showUpdatePayment(cngeNote: any): any {
    const isCallCenter= this.userInfo.callCenter;
    const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;
    const {
      cnoteStatus, createBy
    } = cngeNote;

    let hideButton = false;

    if(!this.isSSUser) {
      hideButton = true;
      return !hideButton;
    }

    if (!isCallCenter ||
      cnoteStatus === "CANCELLED" ||
      (cnoteStatus === "PENDING" && (issueOnBehalf === true || issueOnEndorsement === true) && createBy !== userId)) {
      hideButton = true;
    }

    return !hideButton;
  }

  showUpdateUpdateJPJ(cngeNote: any): boolean {
    let showUpdateJPJ = true;

    const { cnoteStatus, createBy, updateBy } = cngeNote;
    const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;

    let jpjStatus = cngeNote?.jpjStatus;
    if (!jpjStatus && this.responseData?.riskList?.length > 0) {
      jpjStatus = this.responseData.riskList[0].jpjStatus;
    }

    if ((issueOnBehalf || issueOnEndorsement) &&
        (createBy !== userId && updateBy !== userId)) {
        console.log("Update JPJ Details Button hidden because user is issuing on behalf or endorsement and is not the creator/updater.");
        showUpdateJPJ = false;
    }

    if (cnoteStatus !== "PRINTED") {
        console.log(`Update JPJ Details Button hidden because cnoteStatus is ${cnoteStatus}, which is not PRINTED.`);
        showUpdateJPJ = false;
    }

    if (cnoteStatus === "PRINTED" && (jpjStatus !== "NOT OK")) {
        console.log(`Update JPJ Details Button hidden because cnoteStatus is PRINTED but jpjStatus is ${jpjStatus}, which is expects NOT OK.`);
        showUpdateJPJ = false;
    }

    return showUpdateJPJ;
  }

  showAmendCoverNote(cngeNote: any): any { //AGIC-50962
    const { cnoteStatus, cnoteType, policyNo, createBy, updateBy } = cngeNote;
    const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;

    let jpjStatus = cngeNote?.jpjStatus;
    if (!jpjStatus && this.responseData?.riskList?.length > 0) {
      jpjStatus = this.responseData.riskList[0].jpjStatus;
    }
    let hideButton = false;
 
    if (cnoteStatus !== "PRINTED" && cnoteStatus !== "SUBMITTED" && cnoteStatus !== "APPROVED") {
      console.log(`Amend Open Date Button hidden because cnoteStatus is ${cnoteStatus}`);
      hideButton = true;
    } else if (!(jpjStatus === "OK" || jpjStatus === "USED")) {
      console.log(`Amend Open Date Button hidden because jpjStatus is ${jpjStatus}, which is not OK or USED.`);
      hideButton = true;
    } else if ((issueOnBehalf || issueOnEndorsement) && (createBy !== userId && updateBy !== userId)) {
      console.log("Amend Open Date Button hidden because user is issuing on behalf or endorsement AND neither createBy nor updateBy matches userId");
      hideButton = true;
    } else if (cnoteType !== 'NWNN') {
      console.log(`Amend Open Date Button hidden because cnoteType not NWNN`);
      hideButton = true;
    } else if (policyNo) {
      console.log(`Amend Open Date Button hidden because policyNo exist`);
      hideButton = true;
    }

    return !hideButton;
  }

  // showAmendCoverNote(cngeNote: any): boolean {
  //   let showAmend = true;

  //   const { cnoteStatus, createBy, updateBy } = cngeNote;
  //   const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;

  //   let jpjStatus = cngeNote?.jpjStatus;
  //   if (!jpjStatus && this.responseData?.riskList?.length > 0) {
  //     jpjStatus = this.responseData.riskList[0].jpjStatus;
  //   }

  //   if ((issueOnBehalf || issueOnEndorsement) &&
  //       (createBy !== userId && updateBy !== userId)) {
  //       console.log("Amend Open Date Button hidden because user is issuing on behalf or endorsement and is not the creator/updater.");
  //       showAmend = false;
  //   }

  //   if (cnoteStatus !== "PRINTED" && cnoteStatus !== "SUBMITTED") {
  //       console.log(`Amend Open Date Button hidden because cnoteStatus is ${cnoteStatus}, which is neither PRINTED nor SUBMITTED.`);
  //       showAmend = false;
  //   }

  //   if (cnoteStatus === "PRINTED" && (jpjStatus !== "OK" && jpjStatus !== "USED")) {
  //       console.log(`Amend Open Date Button hidden because cnoteStatus is PRINTED but jpjStatus is ${jpjStatus}, which is not OK or USED.`);
  //       showAmend = false;
  //   }

  //   return showAmend;
  // }

  async updateProductList(agentCode, productCode) {
    this.productList = this.lov?.productList;
    if (!this.productList) {
      let productListPayload = {
        lob: 'MT',
        agentCode: agentCode
      };

      await firstValueFrom(this.store.dispatch(new GET_PRODUCT_LIST(productListPayload)));
      this.productList = this.lov?.productList;
    }

    let product = this.productList.find(e => e.code === productCode);
    if (product) {
      let descp = product.descp
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
      console.log(this.productList);
      this.productName = {
        descp: descp
      }
    }

    this.getCoverDescription(productCode);
  }

  getCoverDescription(productCode) {
    const productAccessConfigList = this.lov?.productAccessConfigList;
    if (!productAccessConfigList) return;

    const coverListLov = productAccessConfigList.reduce((list, product) => {
      return list.concat(product[productCode]?.coverList || []);
    }, []);

    const coverCodeVal = this.coverageInfo?.coverageDetails?.coverCode;

    if (coverCodeVal) {
      const matchingCover = coverListLov.find(cover => cover.coverCode === coverCodeVal);
      if (matchingCover) {
        const updatedCoverageDetails = {
          ...this.coverageInfo.coverageDetails,
          coverDescription: matchingCover.coverDescription
        };

        this.coverageInfo = {
          ...this.coverageInfo,
          coverageDetails: updatedCoverageDetails
        };
      }
    }
  }

  getCoverageFromPolicy(policy) {
    let riskList = policy.riskList[0];
    let coverageData: any;

    coverageData = {
      coverage: {
        coveragePremium: {
          cngeNote: policy,
        },
        coverageType: {
          ...riskList.coverList[0],
        },
        extracover: {
          driverNameDetails: {
            rows: riskList.cngeRiskDrvrDtoList,
          },
          ehailingDriverDetails: {},
          extraCoverPackage: {},
        },
        vehicleDetails: {
          ...riskList,
        }
      }
    };

    if (coverageData) {
      this.coverageInfo = coverageData;
    }
  }

  showComponents() {
    if (this.isProgressTypeCN) {
      this.showAgentInfo = true;
      this.showIssuanceInfo = true;
      this.showCustomerPartner = true;
      this.showCoverage = true;
      this.showHistoricalClaim = true;
      this.showPremiumInformation = true;
      this.showReferCase = false;

      if (this.userInfo.callCenter) {
        this.showPaymentDetails = true;
        this.showPaymentInformation = true;
        this.showPayment = true;
        this.showRoadTaxPayable = true;
        this.showUpsellProduct = true;
      }
    }

    if (this.isRTP) {
      this.showAgentInfo = true;
      this.showIssuanceInfo = true;
      this.showCustomerPartner = true;
      this.showCoverage = true;
      this.showHistoricalClaim = true;
      this.showPremiumInformation = true;
      this.viewQuotation = true;
      this.progressType = 'rtp';
    }
  }

  componentDialogRef?: NxModalRef<SummaryPopupComponent>;

  openPopup(popup_type: any) {

    this.componentDialogRef = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
  }
  componentDialogRef1?: NxModalRef<EnquiryPopupComponent>;

  openPopupQuot(popup_type: any) {
    this.componentDialogRef1 = this.dialogService.open(EnquiryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "400px",
      maxWidth: "400px",
      data: { popup_type: popup_type },
    });
  }


  openPopupOCC(popup_type: any) {
    this.componentDialogRef = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      height: '500px',
      data: { popup_type: popup_type },
    });
  }

  goToIssueDeclaration() {

    this.router.navigate(['issuance/declaration-issuance-info'], {
      queryParamsHandling: 'preserve',
    });

  }

  validateReferral() {

    if (this.referralForm.invalid) {
      this.referralForm.markAllAsTouched();
    }

  }

  validateReferCase() {
    if (this.referCaseForm.invalid) {
      console.log("referCaseForm invalid!");
      this.referCaseForm.markAllAsTouched();
    } else {
      console.log("referCaseForm valid...");
    }
  }

  validateRenewalAssistance() {
    if (this.renewalAssistanceForm.invalid) {
      console.log("renewalAssistanceForm invalid!");
      this.renewalAssistanceForm.markAllAsTouched();
    } else {
      console.log("renewalAssistanceForm valid...");
    }
  }

  redirectBack() {
      this.redirectToSummary();
  }

  redirectToSummary() {
    this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe(state => {
      window.location.href = state.SatMotorState.data.switchSiteUrl;
    });
  }

  sendToJPJ() {

    let cngeNotePayload;
    let address1 = this.cpData.clientPartnerAddress.clientAddress1Tmp?.trim();
    let emailValue = this.cpData.clientEmail?.trim();
    this.motorPC = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    this.lovproductConfig = this.lov.productAccessConfigList;

    let hasSendToJpj = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step4?.sendToJPJ);

    if(hasSendToJpj){
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: "Record has been updated by someone. Please re-select the record again"
        }
      });
      return;
    }

    for (let i = 0; i < this.lovproductConfig.length; i++) {
      this.productAccessListData = this.lovproductConfig[i];
      this.lovPC = Object.keys( this.productAccessListData)[0]; 
    
        if (this.lovPC === this.motorPC) {
         this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;
        }
    }
  
    if(((!address1) && (!emailValue)) && ((this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd))){
      this.openPopupQuot("addrEmailQuo");
    }
    else if(((address1) && (!emailValue)) && ((this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd))){
      this.openPopupQuot("emailQuo");
    }
    else if ((!address1) && ((emailValue)||(!emailValue))) {
      this.openPopupQuot("address1Quo");
    }
    else {
      cngeNotePayload = {
        data: this.generateSendToJPJPayload(),
        isCngeNoteExist: true
      }

      let resetPayload = {
        isRTP: false
      };

      this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
      this.store.dispatch(new SEND_TO_JPJ(cngeNotePayload)).subscribe(() => {
        let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
        if (response && response.data && response.success && response.data?.contractId) {
          let updatedContractId = response?.data?.contractId;
          if (updatedContractId && response?.data?.cnoteStatus === 'PRINTED') {
            this.cngeNote = {
              ...this.cngeNote,
              contractId: updatedContractId
            }
            this.downloadPDF('covernote', true);
          }
          this.searchCoverNoteByContractId("SUMMARY", false);
        }

        let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
        if (message) {
          this.okMessageModal = this.dialogService.open(OkMessageComponent, {
            disableClose: true,
            width: '400px',
            data: {
              message: message
            }
          });
        } else if (response.messageConfirm && response.messageHeader) {
          this.showConfirmationMessage(response, cngeNotePayload, 'sendToJPJ');
        }

      });
    }
  }

  showConfirmationMessage(response, payload, apiName) {
    this.confirmMessageModal = this.dialogService.open(ConfirmationModalComponent, {
      showCloseIcon: false, width: "550px", maxWidth: "550px",
      disableClose: true,
      data: { message: response.messageConfirm, type: response.messageHeader },
    });
  
    this.confirmMessageModal.afterClosed().subscribe(result => {
      if (result) {
        let resendPayload = {
          data: {
            cngeNote: {
              ...payload.data.cngeNote,
              skipErrorAndProceed: true
            },
            operator: this.userInfo.userId
          },
          isCngeNoteExist: true
        };
        
        if (apiName === 'amendOpenDate') {
          this.store.dispatch(new AMEND_OPENDATE(resendPayload)).subscribe(() => {
            let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.amendOpenDate ?? null);
            this.handleResponse(response, payload, apiName);
          });
        } else if (apiName === 'resendJPJ') {
          let resendJPJPayload = {
            ...payload,
            skipErrorAndProceed: true
          };

          this.store.dispatch(new RESEND_JPJ(resendJPJPayload)).subscribe(() => {
            let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.resendJPJ ?? null);
            this.handleResponse(response, payload, apiName);
          });
        } else {
          this.store.dispatch(new SEND_TO_JPJ(resendPayload)).subscribe(() => {
            let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
            this.handleResponse(response, payload, apiName);
          });
        }
      }
    });
  }
  
  handleResponse(response, payload, apiName) {
    console.log(response);
  
    if (response && response.data && response.success && response.data.contractId) {
      let updatedContractId = response?.data?.contractId;
      if (updatedContractId && response?.data?.cnoteStatus === 'PRINTED') {
        this.cngeNote = {
          ...this.cngeNote,
          contractId: updatedContractId
        };
        this.downloadPDF('covernote', true);
      }
      this.searchCoverNoteByContractId("SUMMARY", false);
      this.exitUpdateScreen();
    }
  
    let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
    if (message) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: message
        }
      });
    } else if (response.messageConfirm && response.messageHeader) {
      this.showConfirmationMessage(response, payload, apiName);
    }
  }
  

  generateSendToJPJPayload() {
    let cngeNoteView = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);
    let data = {
      cngeNote: {
        ...cngeNoteView,
        cnoteDate: new Date().toISOString().substring(0, 10),
        issueBy: this.userInfo.userId,
        issuedDate: new Date().toISOString().substring(0, 10)
      },
      operator: this.userInfo.userId,
    };

    return data;
  }

  downloadCoverNotePDF(type: string, autoDownload: boolean) { //AGIC-52814
    const payload: any = {
      operator: this.userInfo.userId,
      contractId: this.cngeNote.contractId,
      type: type,
    };
  
    let vehicleNo = this.responseData?.riskList[0]?.vehicleNo ?? null;
    let cnoteType = this.cngeNote.cnoteType;

    this.store.dispatch(new CHECK_PRINTING_CUTOFF(this.cngeNote.contractId)).subscribe((state) => {
      let cutOffResponse = state.SatMotorState.validateCutOff;

      if (cutOffResponse && cutOffResponse.success) {
        if (type === 'covernote' && !autoDownload && !(cnoteType === 'NWNN' && vehicleNo === 'NA')) {
          this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
            disableClose: true,
            width: '450px',
            maxWidth: '450px',
          });
          this.clauseMsgModal.afterClosed().subscribe(result => {
            payload.printClauseInd = (result === 'Y');
            this.store.dispatch(new DOWNLOAD_PDF(payload));
          });
        } else {
          this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe();
        }
      } else {
        this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe();
      }
    });
  }

  downloadQuotationPDF(type: string, autoDownload: boolean) {
    this.store.dispatch(new CHECK_PRINTING_CUTOFF(this.cngeNote.contractId)).subscribe((state) => {
      let cutOffResponse = state.SatMotorState.validateCutOff;

      if (cutOffResponse && cutOffResponse.message && !cutOffResponse.success) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: cutOffResponse.message
          }
        });
      } else {
        this.downloadPDF(type, autoDownload);
      }
    });
  }

  downloadPDF(type: string, autoDownload: boolean) {
    const payload: any = {
      operator: this.userInfo.userId,
      contractId: this.cngeNote.contractId,
      type: type,
    };
  
    let vehicleNo = this.responseData?.riskList[0]?.vehicleNo ?? null;
    let cnoteType = this.cngeNote.cnoteType;

    if (type === 'covernote' && !autoDownload && !(cnoteType === 'NWNN' && vehicleNo === 'NA')) {
      this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
        disableClose: true,
        width: '450px',
        maxWidth: '450px',
      });
      this.clauseMsgModal.afterClosed().subscribe(result => {
        payload.printClauseInd = (result === 'Y');
        this.store.dispatch(new DOWNLOAD_PDF(payload));
      });
    } else {
      this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe();
    }
  }

  onChangeRenewalAssistanceForm(fieldName: any, value: any) {
    console.log('onChangeValue..' + value.checked);
    if (fieldName == 'renewalAssistant') {
      //this.renewalAssistanceForm.controls.paymentMode.reset();
      this.renewalAssistanceForm.controls.paymentMode.clearValidators();
      this.renewalAssistanceForm.controls.creditCardNo.clearValidators();
      this.renewalAssistanceForm.controls.creditCardExpiryDateMonth.clearValidators();
      this.renewalAssistanceForm.controls.creditCardExpiryDateYear.clearValidators();
      this.renewalAssistanceForm.controls.nameOnCard.clearValidators();
      this.renewalAssistanceForm.controls.renewalAssistanceStartDate.clearValidators();
      this.renewalAssistanceForm.controls.termofUse.clearValidators();
      if (value == true) {
        this.renewalAssistanceForm.controls.paymentMode.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardNo.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpiryDateMonth.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpiryDateYear.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.nameOnCard.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.renewalAssistanceStartDate.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.termofUse.setValidators([Validators.required]);
      } else {
        this.renewalAssistanceForm.controls.paymentMode.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardNo.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpiryDateMonth.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpiryDateYear.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.nameOnCard.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.renewalAssistanceStartDate.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.termofUse.removeValidators([Validators.required]);
      }
      this.renewalAssistanceForm.controls.paymentMode.updateValueAndValidity();
      this.renewalAssistanceForm.controls.creditCardNo.updateValueAndValidity();
      this.renewalAssistanceForm.controls.creditCardExpiryDateMonth.updateValueAndValidity();
      this.renewalAssistanceForm.controls.creditCardExpiryDateYear.updateValueAndValidity();
      this.renewalAssistanceForm.controls.nameOnCard.updateValueAndValidity();
      this.renewalAssistanceForm.controls.renewalAssistanceStartDate.updateValueAndValidity();
      this.renewalAssistanceForm.controls.termofUse.updateValueAndValidity();
    }
  }

  uploadDocument() {

    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        contractId: this.cngeNote.contractId,
        productCode: this.cngeNote.productCode
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig);

  }

  prepareCancellationData() {
    this.store.dispatch(new GET_QUOTATION_DETAIL(this.cngeNote.contractId, "SUMMARY")).subscribe((state) => {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);
      
      if (cngeNote) {
        console.log("Current JPJ status: "+cngeNote.jpjStatus);
        this.cngeNote = cngeNote;
        this.openRequestCancellationPopUp();
      }
    });
  }

  openRequestCancellationPopUp() {

    if (this.cngeNote.cnoteNo && this.cngeNote.cnoteStatus === "PRINTED" && !this.cngeNote.jpjStatus) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        width: "410px",
        maxWidth: "410px",
        showCloseIcon: false,
        disableClose: true,
        autoFocus: false,
        data: {
          message: "JPJ Status Pending, please try again."
        }
      });
      return;
    }

    if(this.cngeNote.cnoteNo && this.cngeNote.cnoteStatus === "PRINTED" && this.cngeNote.jpjStatus === "SENT") {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        width: "410px",
        maxWidth: "410px",
        showCloseIcon: false,
        disableClose: true,
        data: {
          message: "JPJ Status Sent, please try again."
        }
      });
      return;
    }

    let data = {
      summaryData: this.cngeNote
    }

    this.requestCancellationModal = this.dialogService.open(RequestCancellationComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: "95%",
      maxHeight: "736px",
      data: data
    });

    this.requestCancellationModal.afterClosed().subscribe(result => {
      if(result) {
        let payload = {
          cancelRemarks: result.data.cancelRemarks,
          cancelReasonCode: result.data.cancellationReason,
          contractId: this.cngeNote.contractId,
          operator: this.userInfo.userId
        };

        if (result.isCancelAndReplace) {

          if(this.hasCoverNoteGenerated() && this.cngeNote.jpjStatus === "OK" && this.cngeNote.policyNo) {
            this.isNotAllowCancel = true;
            of(window).pipe(delay(300)).subscribe(() => {
              window.scroll(0, 0);
            });
            
          } else {
            this.store.dispatch(new CANCEL_REPLACE(payload)).subscribe((state) => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              // let populateData = {
              //   ...cancellationRes,
              //   ...state.SatMotorState.viewQuotation
              // };
              this.store.dispatch(new GET_PRODUCT_LIST({ lob: cancellationRes.productType, agentCode: cancellationRes.mkagAgent.agentCode })).subscribe((state) => {
                this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(cancellationRes)).subscribe(stateLevel2 => {
                  //let vehicleDetails = stateLevel2?.SatMotorState?.motor?.step3?.coverage?.vehicleDetails;
                  //let coverageType = stateLevel2?.SatMotorState?.motor?.step3?.coverage?.coverageType;
                  this.store.dispatch(new SET_ACTION("ISSUE"));
                  this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ({
                    isIssuance: true
                  }));
                  this.store.dispatch(new IS_CANCEL_REPLACE_COVER_NOTE(state.SatMotorState.viewQuotation));
                 // if (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) {

                    /*this.store.dispatch(new GET_NCD_ENQUIRY(this.getNcdData(cancellationRes))).subscribe((state) => {

                      let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
                      if (ncdInfo) {
                        this.store.dispatch(new STORE_NCD_INFO(ncdInfo));
                        let ncdPercentage;
                        let ncdEffDate;
                        const currPctExpDate = new Date(ncdInfo.currPctExpDate);
                        const nextNcdPctEffDate = new Date(ncdInfo.nextNcdPctEffDate);
                        const todaysDate = new Date(this.cngeNote.effectiveDate);

                        if (cancellationRes) {
                          ncdEffDate = cancellationRes?.effectiveDate;
                          if (cancellationRes?.cnoteType === 'NWNN')
                            ncdEffDate = new Date().toISOString().slice(0, 10);
                        }

                        if (currPctExpDate < todaysDate || todaysDate >= nextNcdPctEffDate) {
                          ncdPercentage = ncdInfo.nextNcdPct;
                        } else {
                          ncdPercentage = ncdInfo.currNcdPct;
                        }

                        cancellationRes = {
                          ...cancellationRes,
                          riskList: [{
                            ...cancellationRes.riskList[0],
                            prevNcdEffDate: ncdInfo.currPctEffDate,
                            prevNcdExpDate: ncdInfo.currPctExpDate,
                            ncdEffDate: ncdEffDate,
                            nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
                            nextNcdPct: ncdPercentage
                          }]
                        }

                        vehicleDetails = {
                          ...vehicleDetails,
                          prevNcdEffDate: ncdInfo.currPctEffDate,
                          prevNcdExpDate: ncdInfo.currPctExpDate,
                          ncdEffDate: ncdEffDate,
                          nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
                          nextNcdPct: ncdPercentage
                        }
  
                        coverageType = {
                          ...coverageType,
                          prevNcdEffDate: ncdInfo.currPctEffDate,
                          prevNcdExpDate: ncdInfo.currPctExpDate,
                          ncdEffDate: ncdEffDate,
                          nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
                          nextNcdPct: ncdPercentage,
                          ncdPercentage: ncdPercentage
                        }
  
                        this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(vehicleDetails))
                        this.store.dispatch(new STORE_COVERAGE_TYPE(coverageType))
                      }*/
                      this.calculatePremiumCancelReplace(cancellationRes, this.cngeNote);
                    /*});*/

                  // } else {
                  //   this.router.navigate(["/issuance/coverage"]);
                  // }
                });
              });
            });
          }
          
        } else {
          if(this.isQuotation) {
            this.store.dispatch(new CANCEL_QUOTATION(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if(cancellationRes) {
                this.searchCoverNoteByContractId("SUMMARY", false, this.cngeNote.contractId);
                this.isDirectCancel = true;
              }
            });
          } else {
            this.store.dispatch(new CANCEL_COVER_NOTE(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if(cancellationRes) {
                this.searchCoverNoteByContractId("SUMMARY", false, this.cngeNote.contractId);
                this.isDirectCancel = true;
              }
            });
          }
        }
      }
    });
  }

  updateQuotation() {
    this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(false));
    if (this.isCCentric) {
      const param = {
        "opportunityId": this.queryParams.opportunityId,
        "action": "SUMMARY-UPDATE",
      };
      this.store.dispatch(new UPDATE_QUOTATION_GET_CCENTRIC_OPPORTUNITY_INFO(param)).subscribe((state) => {
        let updateQuotationDetails = state.SatMotorState.updateQuotation;
        if (updateQuotationDetails) {
          if (updateQuotationDetails.cnoteType === 'ENDT') {
            this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          } else if (updateQuotationDetails.cnoteType === 'RP') {
            this.store.dispatch(new SET_ACTION(ACTIONS.RTP));
          } else {
            this.store.dispatch(new SET_ACTION(ACTIONS.ISSUE));
          }
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updateQuotationDetails.productType, agentCode: updateQuotationDetails.mkagAgent.agentCode })).subscribe((stateLevel1) => {
            let hasAdditionalPage = this.isCallCenterUser() || updateQuotationDetails?.mkagAgent?.bancaAgent || updateQuotationDetails?.mkagAgent?.sundriesAgent;
            this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION({...updateQuotationDetails, hasAdditionalPage: hasAdditionalPage})).subscribe(stateLevel2 => {
              const vehicleDetails = stateLevel2.SatMotorState.motor.step3.coverage.vehicleDetails;
              if (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) {

                console.log(this.latestPremiumCalculation);
                console.log(updateQuotationDetails);

                //payload already unsync
                let patchedLatestPremiumCalculation = this.latestPremiumCalculation;
                if (updateQuotationDetails) {
                  patchedLatestPremiumCalculation = {
                    ...patchedLatestPremiumCalculation,
                    riskList: [{
                      ...patchedLatestPremiumCalculation?.riskList?.[0],
                      ...(updateQuotationDetails?.riskList?.[0]?.vehModelNvic && { vehModelNvic: updateQuotationDetails.riskList?.[0]?.vehModelNvic }),
                      engineType: updateQuotationDetails.riskList?.[0]?.engineType
                    }],
                  };

                  if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage) {

                    let coverDto;
                    if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0].subCovPackage === 'HSBC_0100') {  //added for BMW HSBC package
                      coverDto = {
                        extCovPackageSelected: patchedLatestPremiumCalculation?.riskList?.[0]?.coverList?.[0].subCovPackage
                      }
                    } else {
                      coverDto = {
                        ...patchedLatestPremiumCalculation.riskList[0].coverList[0].coverDto,
                        extCovPackageSelected: updateQuotationDetails.riskList[0].coverList[0].subCovPackage
                      }
                    }

                    patchedLatestPremiumCalculation = {
                      ...patchedLatestPremiumCalculation,
                      riskList: [
                        {
                          ...patchedLatestPremiumCalculation.riskList[0],
                          coverList: [
                            {
                              ...patchedLatestPremiumCalculation.riskList[0].coverList[0],
                              subCovPackage: updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage,
                              subCovPackageDesc: updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackageDesc,
                              coverDto: coverDto,
                            }
                          ]
                        }
                      ]
                    };
                  }
                }

                this.store.dispatch(new ISSUANCE_CALCULATE_PREMIUM_SUMMARY({ cngeNote: patchedLatestPremiumCalculation ?? updateQuotationDetails, operator: this.userInfo.userId })).subscribe(stateLevel3 => {
                  let latestCoveragePremium = stateLevel3?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0];
                  let hasSubCovPackageList = latestCoveragePremium?.coverDto?.subCovPackageList;
                  let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.updateQuotation?.riskList?.[0].coverList?.[0].subCoverList);
                  let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);

                  if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
                    let latestSubCovList = latestCoveragePremium?.coverDto?.subCovList;

                    if (hasWaiver) {
                      latestSubCovList = latestSubCovList?.map(obj => {
                        if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                          return { ...obj, selected: true }
                        }
                        return obj;
                      })
                    }

                    patchedLatestPremiumCalculation = {
                      ...patchedLatestPremiumCalculation,
                      riskList: [{
                        ...patchedLatestPremiumCalculation.riskList[0],
                        coverList: [{
                          ...patchedLatestPremiumCalculation.riskList[0].coverList[0],
                          coverDto: {
                            ...patchedLatestPremiumCalculation.riskList[0].coverList[0].coverDto || {},
                            subCovList: latestSubCovList || [],
                            subCovPackageList: hasSubCovPackageList
                          }
                        }]
                      }]
                    };

                    this.store.dispatch(new ISSUANCE_CALCULATE_PREMIUM_SUMMARY({ cngeNote: patchedLatestPremiumCalculation ?? updateQuotationDetails, operator: this.userInfo.userId })).subscribe(stateLvl4 => {
                      let premiumResponse = stateLvl4.SatMotorState.motor.step3.coverage.coveragePremium.cngeNote;
                      this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION({ ...premiumResponse, hasAdditionalPage: hasAdditionalPage })).subscribe(() => {
                        this.copyReady$
                          .pipe(takeUntil(this.destroy$))
                          .subscribe((stateLvl4) => {
                            if (stateLvl4) {
                              this.router.navigate(["/issuance/summary"]);
                            }
                          });
                      });
                    });
                  } else {
                    let premiumResponse = stateLevel3.SatMotorState.motor.step3.coverage.coveragePremium.cngeNote;
                    this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION({ ...premiumResponse, hasAdditionalPage: hasAdditionalPage })).subscribe(() => {
                      this.copyReady$
                        .pipe(takeUntil(this.destroy$))
                        .subscribe((state) => {
                          if (state) {
                            this.router.navigate(["/issuance/summary"]);
                          }
                        });
                    });
                  }
                });
              } else {
                this.copyReady$
                  .pipe(takeUntil(this.destroy$))
                  .subscribe((state) => {
                    if (state) {
                      this.router.navigate(["/issuance/coverage"]);
                    }
                  });
              }
            });
          });
        }
      });
    } else {
      this.store.dispatch(new GET_QUOTATION_DETAIL_REQUOTE(this.queryParams.contractId, "SUMMARY-UPDATE")).subscribe((state) => {
        let updateQuotationDetails = state.SatMotorState.updateQuotation;
        if (updateQuotationDetails) {
          if (updateQuotationDetails.cnoteType === 'ENDT') {
            this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          } else if (updateQuotationDetails.cnoteType === 'RP') {
            this.store.dispatch(new SET_ACTION(ACTIONS.RTP));
          } else {
            this.store.dispatch(new SET_ACTION(ACTIONS.ISSUE));
            updateQuotationDetails = {
              ...updateQuotationDetails,
              cnoteDate: new Date().toISOString().substring(0, 10)
            }
          }
          let hasAdditionalPage = this.isCallCenterUser() || updateQuotationDetails?.mkagAgent?.bancaAgent || updateQuotationDetails?.mkagAgent?.sundriesAgent;

          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updateQuotationDetails.productType, agentCode: updateQuotationDetails.mkagAgent.agentCode })).subscribe((state) => {
            this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION({...updateQuotationDetails, hasAdditionalPage: hasAdditionalPage})).subscribe(stateLevel2 => {

              this.copyReady$
                .pipe(takeUntil(this.destroy$))
                .subscribe((state) => {
                  if (state) {
                    console.log("Perform NCD check.");
                    this.store.dispatch(new STORE_NCD_INFO(updateQuotationDetails?.ncdInfo));
                    this.performNCDCheck(stateLevel2, updateQuotationDetails);
                  }
                });
            });

          });
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  performNCDCheck(stateLevel2: any, updateQuotationDetails: any) {

    let vehicleDetails = stateLevel2.SatMotorState.motor.step3.coverage.vehicleDetails;
    let coverageType = stateLevel2.SatMotorState.motor.step3.coverage.coverageType;

    if (updateQuotationDetails) { // remove .progress impact dashboard summary(renewal) >  update quotation
      //optional package
      if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage) {

        let coverDto;
        if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0].subCovPackage === 'HSBC_0100') {  //added for BMW HSBC package
          coverDto = {
            extCovPackageSelected: updateQuotationDetails?.riskList?.[0]?.coverList?.[0].subCovPackage
          }
        } else {
          coverDto = {
            ...updateQuotationDetails.riskList[0].coverList[0].coverDto,
            extCovPackageSelected: updateQuotationDetails.riskList[0].coverList[0].subCovPackage
          }
        }

        updateQuotationDetails = {
          ...updateQuotationDetails,
          riskList: [
            {
              ...updateQuotationDetails.riskList[0],
              coverList: [
                {
                  ...updateQuotationDetails.riskList[0].coverList[0],
                  coverDto: coverDto
                }
              ]
            }
          ]
        };
      }

      let isAutoRenewal = this.checkAutoRenewal(updateQuotationDetails);

      if(isAutoRenewal){
         updateQuotationDetails = {
          ...updateQuotationDetails,
          riskList: [
            {
              ...updateQuotationDetails.riskList[0],
              coverList: [
                {
                  ...updateQuotationDetails.riskList[0].coverList[0],
                  avInd: updateQuotationDetails.riskList?.[0]?.avInd,
                }
              ]
            }
          ]
        };
      }

      if (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) {
        this.store.dispatch(new GET_NCD_ENQUIRY(this.getNcdData(updateQuotationDetails))).subscribe((state) => {
          this.onNcdResponse("updateQuotationSummary", state, updateQuotationDetails, (updateQuotationDetails) => {
            this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
              let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
              this.patchCoverage(latestCoveragePremium);
              this.recalculatePremium(latestCoveragePremium, updateQuotationDetails, isAutoRenewal, false);
            });
          });
        });
      } else {
        if (isAutoRenewal) {
          this.router.navigate(["/issuance/declaration-issuance-info"]);
        } else {
          this.store.dispatch(new GET_NCD_ENQUIRY(this.getNcdData(updateQuotationDetails))).subscribe((state) => {
            this.onNcdResponse("updateQuotationCoverage", state, updateQuotationDetails, (updateQuotationDetails) => {
              this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
                let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
                this.patchCoverage(latestCoveragePremium);
                this.router.navigate(["/issuance/coverage"]);
              });
            });
          });

        }
      }

    }
  }

  onNcdResponse(action, state, updateQuotationDetails, callback: (updateQuotationDetails) => void) {
    
    let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
    
    if (ncdInfo) {

      this.store.dispatch(new STORE_NCD_INFO(ncdInfo));

      // NCD Enquiry Success
      if (ncdInfo.ismResCode) {
        // Resilent NCD Query
        if (this.NCD_WO_NOTIFICATION.includes(ncdInfo.ismResCode)) {
          if (ncdInfo?.changeNcdToZero) {
            this.dialogService.open(OkMessageComponent, {
              disableClose: true,
              width: "400px", data: { message: ncdInfo.errMsg }
            }).afterClosed().subscribe(() => {
              // set NCD 0
              let updateQt = this.updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, true);
              // calculate premium
              callback(updateQt);
            });
          } 
          else {
            // calculatePremium
            let updateQt = this.updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, false);
            callback(updateQt);
          }
        }

        // Notified NCD Query
        else {
          this.dialogService.open(OkMessageComponent, {
            disableClose: true,
            width: "400px", data: { message: ncdInfo.errMsg }
          }).afterClosed().subscribe(() => {
            // calculatePremium
            let updateQt = this.updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, false);
            callback(updateQt);
          });
        }
      } 
      
      // NCD Enquiry Failed
      else {
        this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: "400px", data: { message: ncdInfo.errMsg }
        }).afterClosed().subscribe(() => {
           // set NCD 0
           let updateQt = this.updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, true);
           // calculate premium
           callback(updateQt);
        });
      }
    } else {
      let updateQt = this.updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, false);
      callback(updateQt);
    }
  }

  updateNcdResponse(ncdInfo, action, state, updateQuotationDetails, resetNcdPercentage: boolean = false) {

    let vehicleDetails = state?.SatMotorState?.motor?.step3?.coverage?.vehicleDetails;
    let coverageType = state?.SatMotorState?.motor?.step3?.coverage?.coverageType;

    let ncdData = {};

    let ncdPercentage, ncdEffDate;
    const currPctExpDate = new Date(ncdInfo.currPctExpDate);
    const nextNcdPctEffDate = new Date(ncdInfo.nextNcdPctEffDate);
    const todaysDate = new Date(updateQuotationDetails.effectiveDate);

    if (updateQuotationDetails) {
      ncdEffDate = updateQuotationDetails?.effectiveDate;
      if (updateQuotationDetails?.cnoteType === 'NWNN') {
        if (ncdInfo?.ismRefNo) {
          ncdEffDate = new Date().toISOString().slice(0, 10);
        } else {
          ncdEffDate = null;
        }
      }
    }

    if (currPctExpDate < todaysDate || todaysDate >= nextNcdPctEffDate) {
      ncdPercentage = ncdInfo.nextNcdPct;
    } else {
      ncdPercentage = ncdInfo.currNcdPct;
    }

    ncdData = {
      prevNcdEffDate: ncdInfo.currPctEffDate,
      prevNcdExpDate: ncdInfo.currPctExpDate,
      ncdEffDate: ncdEffDate,
      nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
      nextNcdPct: resetNcdPercentage ? 0 : ncdPercentage        
    };

    updateQuotationDetails = {
      ...updateQuotationDetails,
      riskList: [{
        ...updateQuotationDetails.riskList[0],
        ismRefNo: ncdInfo?.ismRefNo,
        ...ncdData
      }]
    };

    vehicleDetails = { ...vehicleDetails, ...ncdData };

    if (action === "updateQuotationSummary") {
      vehicleDetails = { ...vehicleDetails, makeModelDesc: (updateQuotationDetails.riskList[0].makeModelDesc ?? vehicleDetails.makeModelDesc) };
    }

    coverageType = { ...coverageType, ...ncdData };

    this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(vehicleDetails));
    this.store.dispatch(new STORE_COVERAGE_TYPE(coverageType));

    return updateQuotationDetails;

  }

  patchCoverage(cngeNote) {
    let coverage = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage);
    let riskList = cngeNote?.riskList;
    for (let rl of riskList) {
      for (let cl of rl?.coverList) {
        if (coverage?.coverageType) {
          this.store.dispatch(new PATCH_STEP3("coverageType", {
            sumInsured: cl?.sumInsured,  
            excessAmount: cl?.excessAmount,  
            annualPremium: cl?.annualPremium,  
            basicPremium: cl?.basicPremium,  
            grossPremium: cl?.grossPremium,  
            allriderPrem: cl?.allriderPrem,  
            ncdPercentage: cl?.ncdPercentage,  
            ncdAmount: cl?.ncdAmount
          }));
        }
      }
    }
  }

  calculatePremiumCancelReplace(updateQuotationDetails, viewQuotationDetails) {
    if (viewQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage) {
        updateQuotationDetails = {
          ...updateQuotationDetails,
          riskList: [
            {
              ...updateQuotationDetails.riskList[0],
              coverList: [
                {
                  ...updateQuotationDetails.riskList[0].coverList[0],
                  subCovPackage: viewQuotationDetails.riskList[0].coverList[0].subCovPackage,
                  // subCovPackageList: [], //51292 - missing jaecoo limited speril
                  //subCoverList: [],
                  coverDto: {
                    //...updateQuotationDetails.riskList[0].coverList[0].coverDto,  //51292 - missing jaecoo limited speril
                    extCovPackageSelected: viewQuotationDetails.riskList[0].coverList[0].subCovPackage
                  }
                }
              ]
            }
          ]
        };
      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
        let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
        this.patchCoverage(latestCoveragePremium);
        this.recalculatePremium(latestCoveragePremium, updateQuotationDetails, false, false);
      });
    }else{
      //calculate premium to calculate latest ncd
      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
        let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
        this.patchCoverage(latestCoveragePremium);
        this.redirectAfterRecalculatePremium(false, false);
      });
    }
  }

  calculatePremiumRequote(updateQuotationDetails) {
    if (updateQuotationDetails) { // remove .progress impact dashboard summary(renewal) >  update quotation      
      //optional package
      if (updateQuotationDetails?.riskList[0]?.coverList[0]?.subCovPackage) {
        updateQuotationDetails = {
          ...updateQuotationDetails,
          riskList: [
            {
              ...updateQuotationDetails.riskList[0],
              coverList: [
                {
                  ...updateQuotationDetails.riskList[0].coverList[0],
                  coverDto: {
                    ...updateQuotationDetails.riskList[0].coverList[0].coverDto,
                    extCovPackageSelected: updateQuotationDetails.riskList[0].coverList[0].subCovPackage
                  }
                }
              ]
            }
          ]
        };
      }

      updateQuotationDetails = {
        ...updateQuotationDetails,
        cnoteStatus : "PRINTED", //added for optional package 
      };

      this.store.dispatch(new GET_NCD_ENQUIRY(this.getNcdData(updateQuotationDetails))).subscribe((state) => {
        this.onNcdResponse("calculatePremiumRequote", state, updateQuotationDetails, (updateQuotationDetails) => {
          this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
            let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium;
            if (latestCoveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.ncdPercentage) {
              latestCoveragePremium = {
                ...latestCoveragePremium,
                cngeNote: {
                  ...latestCoveragePremium.cngeNote,
                  ncdPercentage: latestCoveragePremium.cngeNote.riskList[0].coverList[0].ncdPercentage
                }
              }
            }
            this.patchCoverage(latestCoveragePremium?.cngeNote);
            this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD(latestCoveragePremium))
            this.recalculatePremium(latestCoveragePremium, updateQuotationDetails, false, true);
          });
        });
      });
    }
  }

  recalculatePremium(latestCoveragePremium, cngeNoteUpdated, isAutoRenewal, isRequote){
    if (latestCoveragePremium) {
      let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
      let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0); 
      let hasSubCovPackageList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovPackageList || latestCoveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovPackageList;
      
      if (latestCoveragePremium.alimCustomerIndi || hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
        let latestSubCovList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList || latestCoveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList

        if (hasWaiver) {
          latestSubCovList = latestSubCovList?.map(obj => {
            if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
              return { ...obj, selected: true }
            }
            return obj;
          })
        }

        cngeNoteUpdated = {
          ...cngeNoteUpdated,
          riskList: [{
            ...cngeNoteUpdated.riskList[0],
            coverList: [{
              ...cngeNoteUpdated.riskList[0].coverList[0],
              coverDto: {
                ...cngeNoteUpdated.riskList[0].coverList[0].coverDto|| {},
                subCovList: latestSubCovList || [],
                subCovPackageList: hasSubCovPackageList || []
              }
            }]
          }]
        };

      //for Alim customer without MRW & isWaiver
        this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.userInfo.userId })).subscribe((state) => {
          const latestCngeNote = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
          this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCngeNote)); 
          this.redirectAfterRecalculatePremium(isAutoRenewal, isRequote);
        });
      } else {
        this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCoveragePremium));
        this.redirectAfterRecalculatePremium(isAutoRenewal, isRequote);
      }

    }
  }

  redirectAfterRecalculatePremium(isAutoRenewal, isRequote){
    let vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.vehicleDetails);
    let einvoiceConsentInd =  this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.issuance?.pdpa?.consentDetails?.einvoiceConsentInd);
    let step2 =  this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step2);
    
    if(isRequote){
      return;
    }

    if (isAutoRenewal) {
      this.router.navigate(["/issuance/declaration-issuance-info"]);
    } else {
      if(einvoiceConsentInd && (!step2?.clientTinNo || !step2?.clientEmail || !step2?.clientMobileCode1 || !step2?.clientMobileNo1)){
        this.router.navigate(["/issuance/customer-partner"]);
      }else if (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) {
        this.router.navigate(["/issuance/summary"]);
      }else{
        this.router.navigate(["/issuance/coverage"]);
      }
      
    }
  }

  checkAutoRenewal(cngeNote) {
    if (cngeNote.proposalNo.startsWith('AQ') && !cngeNote.progress) {
      return true;
    } else {
      return false;
    }
  }

  showRemarksModal() {
    this.remarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus : false,
      data: {
        title: "Enter Remarks",
        primaryButtonLabel: "SUBMIT"
      }
    });

    this.remarksModal.afterClosed().subscribe(result => {
      if(result) {
        const data = {
          contractId : this.cngeNote.contractId,
          remark: result.remarks,
          operator: this.userInfo.userId,
          isViewQuotation: true
        };

        this.store.dispatch(new SAVE_REFERRAL_REMARKS(data)).subscribe(state => {
          let referRemarkList = state.SatMotorState.viewQuotation?.cngeNote?.referRemarkList ?? null;
          if (referRemarkList) {
            this.remarksInfo = {
              ...this.remarksInfo,
              referral: referRemarkList
            }
          }
        });
      }
    });
  }

  updatePayment() {
    if (this.isCCentric) {
      const param = {
        "opportunityId": this.queryParams.opportunityId,
        "action": "SUMMARY"
      };
      this.store.dispatch(new GET_CCENTRIC_OPPORTUNITY_INFO(param)).subscribe((state) => {
        let updatePaymentDetails = state.SatMotorState.viewQuotation;
        if (updatePaymentDetails) {
          this.store.dispatch(new SET_OPPORTUNITY_ID(updatePaymentDetails.oppurtunityId));
          this.store.dispatch(new SET_UPDATE_PAYMENT_IND(true));
          this.store.dispatch(new SET_ACTION(ACTIONS.ISSUE));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updatePaymentDetails.productType, agentCode: updatePaymentDetails.mkagAgent.agentCode })).subscribe((stateLevel1) => {
            
            let calculatePremiumPayload = state?.SatMotorState?.viewQuotation;

            if (calculatePremiumPayload?.riskList[0]?.coverList[0]?.subCovPackage) {
              calculatePremiumPayload = {
                ...calculatePremiumPayload,
                riskList: [
                  {
                    ...calculatePremiumPayload.riskList[0],
                    coverList: [
                      {
                        ...calculatePremiumPayload.riskList[0].coverList[0],
                        coverDto: {
                          ...calculatePremiumPayload.riskList[0].coverList[0].coverDto,
                          extCovPackageSelected: calculatePremiumPayload.riskList[0].coverList[0].subCovPackage
                        }
                      }
                    ]
                  }
                ]
              };
            }
            
            this.store.dispatch(new ISSUANCE_CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(stateLevel2 => {
              let premiumResponse = stateLevel2.SatMotorState.motor.step4.summary.coverageInfo.coverage.coveragePremium.cngeNote;
              this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
              let latestCoveragePremium = state?.SatMotorState?.premiumCalculation;
              let hasSubCovPackageList = latestCoveragePremium?.coverDto?.subCovPackageList;
              let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
              let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);

              if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
                let latestSubCovList = latestCoveragePremium?.coverDto?.subCovList;

                if (hasWaiver) {
                  latestSubCovList = latestSubCovList?.map(obj => {
                    if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                      return { ...obj, selected: true }
                    }
                    return obj;
                  })
                }

                calculatePremiumPayload = {
                  ...calculatePremiumPayload,
                  riskList: [{
                    ...calculatePremiumPayload.riskList[0],
                    coverList: [{
                      ...calculatePremiumPayload.riskList[0].coverList[0],
                      coverDto: {
                        ...calculatePremiumPayload.riskList[0].coverList[0].coverDto || {},
                        subCovList: latestSubCovList || [],
                        subCovPackageList: hasSubCovPackageList
                      }
                    }]
                  }]
                };

                this.store.dispatch(new CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(state => {

                  premiumResponse = state.SatMotorState.summaryPremium;
                  this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(premiumResponse)).subscribe(stateLevel3 => {
                    this.router.navigate(["/issuance/summary"]);
                  });
                });
              } else {
                this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(premiumResponse)).subscribe(stateLevel3 => {
                  this.router.navigate(["/issuance/summary"]);
                });
              }
             
            });
          });
        }
      });
    } else {
      this.store.dispatch(new GET_QUOTATION_DETAIL(this.queryParams.contractId, "SUMMARY")).subscribe((state) => {
        let updatePaymentDetails = state.SatMotorState.viewQuotation;
        if (updatePaymentDetails) {
          // this.store.dispatch(new SET_OPPORTUNITY_ID(updatePaymentDetails.oppurtunityId));
          this.store.dispatch(new SET_UPDATE_PAYMENT_IND(true));
          this.store.dispatch(new SET_ACTION(ACTIONS.ISSUE));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updatePaymentDetails.productType, agentCode: updatePaymentDetails.mkagAgent.agentCode })).subscribe((stateLevel1) => {
            let calculatePremiumPayload = state?.SatMotorState?.viewQuotation;

            if (calculatePremiumPayload?.riskList[0]?.coverList[0]?.subCovPackage) {
              calculatePremiumPayload = {
                ...calculatePremiumPayload,
                riskList: [
                  {
                    ...calculatePremiumPayload.riskList[0],
                    coverList: [
                      {
                        ...calculatePremiumPayload.riskList[0].coverList[0],
                        coverDto: {
                          ...calculatePremiumPayload.riskList[0].coverList[0].coverDto,
                          extCovPackageSelected: calculatePremiumPayload.riskList[0].coverList[0].subCovPackage
                        }
                      }
                    ]
                  }
                ]
              };
            }
            this.store.dispatch(new ISSUANCE_CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(stateLevel2 => {
              let premiumResponse = stateLevel2.SatMotorState.motor.step4.summary.coverageInfo.coverage.coveragePremium.cngeNote;
              this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
              let latestCoveragePremium = state?.SatMotorState?.premiumCalculation;
              let hasSubCovPackageList = latestCoveragePremium?.coverDto?.subCovPackageList;
              let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
              let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);

              if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
                let latestSubCovList = latestCoveragePremium?.coverDto?.subCovList;

                if (hasWaiver) {
                  latestSubCovList = latestSubCovList?.map(obj => {
                    if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                      return { ...obj, selected: true }
                    }
                    return obj;
                  })
                }

                calculatePremiumPayload = {
                  ...calculatePremiumPayload,
                  riskList: [{
                    ...calculatePremiumPayload.riskList[0],
                    coverList: [{
                      ...calculatePremiumPayload.riskList[0].coverList[0],
                      coverDto: {
                        ...calculatePremiumPayload.riskList[0].coverList[0].coverDto || {},
                        subCovList: latestSubCovList || [],
                        subCovPackageList: hasSubCovPackageList
                      }
                    }]
                  }]
                };

                this.store.dispatch(new CALCULATE_PREMIUM_SUMMARY({ cngeNote: calculatePremiumPayload, operator: this.userInfo.userId })).subscribe(state => {

                  premiumResponse = state.SatMotorState.summaryPremium;
                  this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(premiumResponse)).subscribe(stateLevel3 => {
                    this.router.navigate(["/issuance/summary"]);
                  });
                });
              } else {
                this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(premiumResponse)).subscribe(stateLevel3 => {
                  this.router.navigate(["/issuance/summary"]);
                });
              }

            });
          });
        }
      });
    }
  }

  performCancel() {
    this.redirectToSummary();
  }

  updateJPJDetails() {
    this.isAmendDateScren = false;
    this.isUpdateJPJScreen = true;

    this.toggleScreen(true);
  }

  amendCoverNote() {
    this.isUpdateJPJScreen = false;
    this.isAmendDateScren = true;

    this.toggleScreen(true);
  }

  toggleScreen(switchToSecondary) {
    if (switchToSecondary) {
      this.showPrimaryScreen = false;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.showSecondaryScreen = true;
        this.cdr.detectChanges();
      }, 100);
    
    } else {
      this.showSecondaryScreen = false;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.showPrimaryScreen = true;
        this.cdr.detectChanges();
      }, 100);
    }
  }

  exitUpdateScreen() {
    this.isUpdateJPJScreen = false;
    this.isAmendDateScren = false;
    this.toggleScreen(false);
    //window.location.reload();
  }

  checkQuotationStatus() {
    if (this.hasCoverNoteGenerated()) {
      this.emailDocument();
    } else {
      this.checkValidationCuttOff();
    }
  }

  checkValidationCuttOff() {
    this.store.dispatch(new GET_EMAIL_CUTOFF(this.cngeNote.contractId)).subscribe((state) => {
      let res = state.SatMotorState?.emailValidationCutOff;

      if (res?.success) {
        this.emailDocument();
      
      } else if (res && !res.success && res.message) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: res.message
          }
        });
      
      } else {
        this.emailDocument();
      }
    });
  }

  emailDocument() {
    this.emailDocumentModal = this.dialogService.open(EmailDocumentComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "95%",
      maxWidth: "900px",
      maxHeight: "95vh",
      data: { popup_type: 'emaildocument' },
    });

    this.emailDocumentModal.afterClosed().subscribe((result: boolean) => {
      if (result === true) {
        this.searchCoverNoteByContractId("SUMMARY", false);
      }
    });
  }

  requote() {

    let contractId = this.isCCentric ? this.cngeNote.contractId : this.queryParams.contractId;

    this.store.dispatch(new GET_QUOTATION_DETAIL_REQUOTE(contractId, "REQUOTE")).subscribe((state) => {
      let requoteQuotationDetails = state.SatMotorState.requoteQuotation;
      let requoteQuotationDetailsError = state.SatMotorState.requoteQuotationError;

      if (requoteQuotationDetailsError) {
        this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: requoteQuotationDetailsError?.message
          }
        });
      }

      if (requoteQuotationDetails) {
        let riskList = requoteQuotationDetails?.riskList[0];
        if (riskList) {
          this.store.dispatch(new SELECTED_MAKE_MODEL({
            avCode: riskList.avCode, 
            avEmSiMax: riskList.avEmSiMax, 
            avEmSiMin: riskList.avEmSiMin, 
            avWmSiMax: riskList.avWmSiMax, 
            avWmSiMin: riskList.avWmSiMin, 
            capacity: riskList.vehicleCapacity,
            classCode: riskList.vehicleClass,
            engineType: riskList.engineType,
            importStatus: riskList.importStatus,
            inactiveInd: riskList.makeModelInactiveInd,
            inactiveSiInd: riskList.makeModelInactiveSiInd,
            nvicCode: riskList.nvicNo,
            piamMakeCode: null,
            piamMakeCodeDesc: riskList.piamMakeCodeDesc,
            piamMakeModelDesc: riskList.piamMakeModelDesc,
            piamModelCode: null,
            piamModelCodeDesc: riskList.piamModelCodeDesc,
            seat: riskList.vehicleSeat,
            series: null,
            transmission: null,
            uom: riskList.uom,
            variant: null,
            variantFullDesc: riskList.variantFullDesc,
            vehModelCodeNvic: riskList.vehModelNvic,
            yearMnftr: riskList.vehicleMakeYear,
          }));
        }

        this.store.dispatch(new GET_PRODUCT_LIST({ lob: requoteQuotationDetails.productType, agentCode: requoteQuotationDetails.mkagAgent.agentCode })).subscribe((state) => {
          this.store.dispatch(new COPY_REQUOTE_INFO(requoteQuotationDetails)).subscribe(state => {
            this.calculatePremiumRequote(requoteQuotationDetails);
            this.store.dispatch(new SET_ACTION(ACTIONS.ISSUE));
            
            //this.router.navigate(["/issuance/declaration-issuance-info"], {});
            const isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
            if (!isSingleAgent) {
              this.store.dispatch(new GET_AGENT_LIST_AGENT({ userId: this.userInfo.userId })).subscribe(() => {
                this.router.navigate(["/agent-selection"], {});
              });
            } else {
              this.router.navigate(["/issuance/declaration-issuance-info"], {}); // for single agent
            }
          });
        });
      }
    });
  }

  resendJPJAction() {
    if (this.vehicleAmendData && this.vehicleAmendData.vehicleDetailForm) {
      const form = this.vehicleAmendData.vehicleDetailForm;
  
      if (form.valid) {
        this.resendJPJ(form.getRawValue());

      } else {
        form.markAllAsTouched();
      }
    }
  }

  saveCNDate() {
    if (this.vehicleAmendData && this.vehicleAmendData.vehicleDetailForm) {
      const form = this.vehicleAmendData.vehicleDetailForm;
      const vehicleNoControl = form.get('vehicleNo');
      const jpjEffectiveDate = form.get('jpjEffectiveDate')?.value;

      if (vehicleNoControl?.value && vehicleNoControl.value !== 'NA' && jpjEffectiveDate) {
        this.amendOpenDate(form.getRawValue());
      } else {
        if (vehicleNoControl?.value === 'NA') {
          vehicleNoControl.markAsTouched();
        }
      }
    }
  }

  parseAndFormatDate(dateString) {
    if (!dateString) {
      return dateString;
    }

    let parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().split('T')[0];
    } else {
      return this.parseDateWithMoment(dateString);
    }
  }

  parseDateWithMoment(dateString) {
    const parsedDate = moment(dateString, moment.ISO_8601, true);
    if (!parsedDate.isValid()) {
      return dateString;
    }
    return parsedDate.format('YYYY-MM-DD');
  }

  amendOpenDate(formValue) {
    const data = this.generateSendToJPJPayload();

    const updatedRisk = {
      ...data.cngeNote.riskList[0],
      vehicleNo: formValue.vehicleNo,
      jpjEffectiveDate: this.parseAndFormatDate(formValue.jpjEffectiveDate),
      jpjExpiryDate: this.parseAndFormatDate(formValue.jpjExpiryDate),
    };

    const updatedCngeNote = {
      ...data.cngeNote,
      riskList: [updatedRisk],
    };

    const updatedData = {
      cngeNoteDto: updatedCngeNote,
      operator: data.operator,
    };

    const updatedPayload = { data: updatedData };
    console.log(updatedPayload);
    
    let resetPayload = {
      isRTP: false
    };

    this.store.dispatch(new AMEND_OPENDATE(updatedPayload)).subscribe(() => {
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.amendOpenDate ?? null);
      if (response && response.data && response.success && response.data?.cngeNoteDto?.contractId) {
        let updatedContractId = response?.data?.cngeNoteDto?.contractId;
        if (updatedContractId && response?.data?.cngeNoteDto?.cnoteStatus === 'PRINTED') {
          this.cngeNote = {
            ...this.cngeNote,
            contractId: updatedContractId
          }
          this.downloadPDF('covernote', true);
        }
        this.searchCoverNoteByContractId("SUMMARY", false);
        this.exitUpdateScreen();
      }

      let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
      if (message) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: message
          }
        });
      } else if (response.messageConfirm && response.messageHeader) {
        this.showConfirmationMessage(response, updatedPayload, 'amendOpenDate');
      }

    });
  }

  resendJPJ(formValue) {
    const data = this.generateSendToJPJPayload();

    const updatedRisk = {
      ...data.cngeNote.riskList[0],
      vehicleNo: formValue.vehicleNo,
      vehicleEngine: formValue.vehicleEngine,
      vehicleChassis: formValue.vehicleChassis,
    };

    const updatedCngeNote = {
      ...data.cngeNote,
      riskList: [updatedRisk],
      operator: data.operator,
    };

    console.log(updatedCngeNote);
 

    this.store.dispatch(new RESEND_JPJ(updatedCngeNote)).subscribe(() => {
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.resendJPJ ?? null);
      if (response && response.data && response.success && response.data?.cngeNoteDto?.contractId) {
        let updatedContractId = response?.data?.cngeNoteDto?.contractId;
        if (updatedContractId && response?.data?.cngeNoteDto?.cnoteStatus === 'PRINTED') {
          this.cngeNote = {
            ...this.cngeNote,
            contractId: updatedContractId
          }
          this.downloadPDF('covernote', true);
        }
        this.searchCoverNoteByContractId("SUMMARY", false);
        this.exitUpdateScreen();
      }

      let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
      if (message) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: message
          }
        });
      } else if (response.messageConfirm && response.messageHeader) {
        this.showConfirmationMessage(response, updatedCngeNote, 'resendJPJ');
      }

    });
  }

  getPaymentData(data) {
    this.payment = {
      receiptNo: data.receiptNo,
      transactionDate: data.receiptDate,
      eCoverNoteNo: data.cnoteNo,
      vehicleNo: data?.riskList[0]?.vehicleNo,
      accountCode: data.mkagAgent.agentCode,
      insuredName: data.clientPartner.clientName,
      totalPremiumDue: data?.riskList[0]?.coverList[0]?.premiumDue,
    };

    this.paymentList = data.paymentList ? data.paymentList : [];

    this.roadTaxPayable = {
      roadTax: data.roadTax,
      myegFees: data.myegFees,
      courierFees: data.courierFees,
      merchantCharges: data.merchantCharges,
      totalRoadTaxPayable: data.totalRoadTaxPayable
    };

    this.paymentInformation = {
      totalPayable: data.totalPayable,
      totalPayableRounded: data.totalPayableRounded,
      totalPaid: data.totalPaid,
      balancePayable: data.balancePayable
    };

    this.upsellProduct = {
      upSellType: data.upSellType,
      upSellAmt: data.upSellAmt
    };
  }

  getNcdData(cngeNote) {
    return {
        cnoteType: cngeNote?.cnoteType,
        cnoteDate: cngeNote?.effectiveDate || cngeNote?.cnoteDate,
        productType: cngeNote?.productCode,
        idType: cngeNote?.clientPartner?.idType1,
        idNo1: cngeNote?.clientPartner?.idValue1,
        idNo2: cngeNote?.clientPartner?.idValue2,
        vehicleUse: cngeNote?.riskList?.[0]?.vehicleUse,
        vehicleNo: cngeNote?.riskList?.[0]?.vehicleNo,
        vehicleClass: cngeNote?.riskList?.[0]?.vehicleClass,
        chassisNo: cngeNote?.riskList?.[0]?.vehicleChassis,
        coverCode: cngeNote?.riskList?.[0]?.coverList?.[0]?.coverCode,
        previousNcdVehicle: cngeNote?.riskList?.[0]?.prevNcdVeh || cngeNote?.riskList?.[0]?.vehicleNo,
        previousNcdInsurer: cngeNote?.riskList?.[0]?.prevNcdInsurer
      };
  }

  isDisableEmailButton(): boolean {
    //return this.cngeNote.edocConsentInd ? false : true;
    return false; //AGIC-46575: should be enable regardless e-Document is Yes/No
  }

  hasCoverNoteGenerated() {
    return this.cngeNote.cnoteNo && this.cngeNote.cnoteNo != '';
  }

  get isShowTopMessage() {
    return this.isNotAllowCancel || (this.hasCoverNoteGenerated() && this.status === this.statusMap['PENDING']) || this.isDirectCancel
    || (this.isQuotation && this.status === this.statusMap['EXPIRED'] && this.message);
  }

  isDisableResendJPJBtn(): boolean {
    if (this.vehicleAmendData && this.vehicleAmendData.vehicleDetailForm) {
      const form = this.vehicleAmendData.vehicleDetailForm;
      return (form.valid) ? false : true;
    } else {
      return true;
    }
  }

  isDisableSaveAmendCNBtn(): boolean {
    if (this.vehicleAmendData && this.vehicleAmendData.vehicleDetailForm) {
        const form = this.vehicleAmendData.vehicleDetailForm;
        const cnoteDate = this.vehicleAmendData.cngeNote?.cnoteDate;

        const vehicleNo = form.get('vehicleNo')?.value;
        const jpjEffectiveDate = form.get('jpjEffectiveDate')?.value;

        if (!vehicleNo || !jpjEffectiveDate || !cnoteDate) {
            return true;
        }

        const issueDate = moment(cnoteDate, "YYYY-MM-DD");
        const effectiveDate = moment(jpjEffectiveDate, "YYYY-MM-DD");

        return effectiveDate.isBefore(issueDate);
    }

    return true;
  }

  get isShowCrossSell() {
    if (this.cngeNote?.cnoteStatus === "CANCELLED" || this.cngeNote?.cnoteStatus === "EXPIRED") {
      return false;
    }

    if (this.isUpdateJPJScreen || this.isAmendDateScren) {
      return false;
    }

    return true;
  }

  get isQuotation() {
    if(!this.cngeNote.cnoteNo && this.cngeNote.proposalNo && !this.cngeNote.draftInd) {
      return true;
    }else {
      return false;
    }
  }

  get isSSUser() {
    if(this.userInfo.callCenter && this.userInfo.callCentreType == "S") {
      return true;
    }else {
      return false;
    }
  }

  isDisableRequestCancel(): boolean {
    const { cnoteNo, createBy, updateBy } = this.cngeNote;
    const { userId, issueOnBehalf, issueOnEndorsement } = this.userInfo;

    const isCoverNote = !!cnoteNo;

    let isDisabled = this.validateAccess(isCoverNote ? AccessConfig.CANCEL_COVER_NOTE : AccessConfig.CANCEL_QUOTATION);
    if (isDisabled) {
      return true;
    }

    isDisabled = (issueOnBehalf || issueOnEndorsement) &&
      (createBy !== userId && updateBy !== userId);

    return isDisabled; //If true means disable
  }

  isCallCenterUser() {
    return this.userInfo?.callCentreType !== undefined;
  }

  warningPopup(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
    this.warningPopupModal.afterClosed().subscribe((result) => {
      this.redirectBack();
    });
  }

  isDisableAmendOpenDateButton(): boolean {
    return this.validateAccess(AccessConfig.AMEND_COVER_NOTE);
  }

  isDisableUpdateJPJButton(): boolean {
    return this.validateAccess(AccessConfig.VIEW_UPDATE_JPJ);
  }

  isDisableUpdateQuotation(): boolean {
    return this.validateAccess(AccessConfig.UPDATE_QUOTATION);
  }

  isDisableUpdatePayment(): boolean {
    return this.validateAccess(AccessConfig.UPDATE_PAYMENT);
  }

  isDisableQuotationPDF(): boolean {
    return this.validateAccess(AccessConfig.QUOTATION_PDF);
  }

  isDisableCoverNotePDF(): boolean {
    return this.validateAccess(AccessConfig.COVER_NOTE_PDF);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }
}